// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedRgbChannelsGreen_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill="#38CD56" d="M0 0H16V16H0z"/>
  <path d="M11.5918 11.5801C10.7715 12.0527 9.75195 12.2891 8.5332 12.2891C7.18164 12.2891 6.11523 11.916 5.33398 11.1699C4.55664 10.4199 4.16797 9.38867 4.16797 8.07617C4.16797 6.75586 4.59375 5.67969 5.44531 4.84766C6.29688 4.01562 7.42969 3.59961 8.84375 3.59961C9.73438 3.59961 10.5195 3.72266 11.1992 3.96875V5.74414C10.5508 5.36914 9.75781 5.18164 8.82031 5.18164C8.03516 5.18164 7.39453 5.4375 6.89844 5.94922C6.40625 6.45703 6.16016 7.13672 6.16016 7.98828C6.16016 8.85156 6.38086 9.51953 6.82227 9.99219C7.26758 10.4648 7.86719 10.7012 8.62109 10.7012C9.07422 10.7012 9.43359 10.6367 9.69922 10.5078V8.86719H8.01758V7.35547H11.5918V11.5801Z" class="svg-fg"/>
</svg>
`;
/**
 * IconMedRgbChannelsGreen is a generated icon component.
 */
let IconMedRgbChannelsGreen = IconMedRgbChannelsGreen_1 = class IconMedRgbChannelsGreen extends IconBaseElement {
    render() {
        return html `${IconMedRgbChannelsGreen_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedRgbChannelsGreen.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s16IconSvg],
    ['s32', _s16IconSvg],
    ['s40', _s16IconSvg],
    ['s48', _s16IconSvg],
    ['s64', _s16IconSvg],
    ['s72', _s16IconSvg],
    ['s80', _s16IconSvg],
]);
IconMedRgbChannelsGreen = IconMedRgbChannelsGreen_1 = __decorate([
    customElement('zui-icon-med-rgb-channels-green')
], IconMedRgbChannelsGreen);
export { IconMedRgbChannelsGreen };
